import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { CalendarIconV2, CompleteAnim, MplButton, MplModal } from '@mopla/ui';

interface ISuccessStepProps {
	open: boolean;
	startDate: string;
	onConfirm: VoidFunction;
}

export const SuccessStep: FC<ISuccessStepProps> = ({
	open,
	startDate,
	onConfirm,
}) => {
	const { t } = useTranslation('subscribeDTicket');
	const formattedDate = dayjs(startDate).format('DD. MMMM YYYY');

	return (
		<MplModal
			open={open}
			testId="subscribe-dticket-success-modal"
			icon={<CompleteAnim />}
			title={t('success_modal.title')}
			content={
				<Stack direction="row" alignItems="center" gap={1}>
					<CalendarIconV2 size={24} color="#0E1C5B" />
					<Typography variant="body1" color="primary.main">
						<Trans
							i18nKey="subscribeDTicket:success_modal.valid_from"
							values={{ date: formattedDate }}
							components={{
								bold: <strong />,
							}}
						/>
					</Typography>
				</Stack>
			}
			buttons={
				<MplButton
					fullWidth
					onClick={onConfirm}
					testId="subscribe-dticket-success-button"
				>
					{t('success_modal.button')}
				</MplButton>
			}
		/>
	);
};
